<template>
    <div>
        <div class="form-info">
            <el-form :model="msgInfo" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                <div class="form-row">
                    <div class="form-label">
                        <label class="required">标题</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="txt">
                            <el-input v-model="msgInfo.txt" type="text"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-row" style="height: 90px">
                    <div class="form-label">
                        <label class="required">内容</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="data">
                            <el-input v-model="msgInfo.data" type="textarea"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
        </div>
        <div class="form-info" v-if="!isVoucher">
            <div class="form-row">
                <div class="form-label">
                    <label class="required">是否跨组织架构</label>
                </div>
                <div class="form-value width-2x">
                    <el-radio-group v-model="transOrgFlag" @change="loadStaffList(transOrgFlag)">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="form-row" v-if="transOrgFlag" style="height: auto;overflow: hidden">
                <div class="form-label">
                    <label>&nbsp;</label>
                </div>
                <div class="form-value flex">
                    <swb-org-tree  :isCom="false" :accordion="true" :isShowIcon="false" @notity-change="notityChange($event)" ref="swb_org_tree"></swb-org-tree>
                </div>
            </div>
            <div class="form-row">
                <div class="form-label">
                    <label>&nbsp;</label>
                </div>
                <div class="form-value flex">
                    <swb-com-staff-list-for-msg :transOrgFlag="transOrgFlag" :comId="comId" ref="swb_com_staff_list_for_msg"></swb-com-staff-list-for-msg>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="form-row">
                <div class="form-label">
                    <label class="required">发送方式</label>
                </div>
                <div class="form-value width-2x">
                    <el-checkbox-group v-model="checkList">
                        <el-checkbox label="comIn" :disabled="true">对内</el-checkbox>
                        <el-checkbox label="comOut">对外</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import comStaffListForMsg from '../orgStruct/ComStaffListForMsg';
    Vue.regist(comStaffListForMsg);
    import OrgTree from '../orgStruct/OrgTree';
    Vue.regist(OrgTree);

    export default{
        name: 'swb-send-msg-mail',
        desc: '站点信',
        props: {
            // 类型： 标记 单据类、组织架构类
            isVoucher: {
                type: Boolean,
                //
                default: false
            },
        },
        data: function () {
            return {
                msgInfo: {
                    data: null,
                    txt: null,
                },
                rules: {
                    data: [
                        {required: true, message: '请输入标题', trigger: 'blur'},
                    ],
                    txt: [
                        {required: true, message: '请输入内容', trigger: 'blur'},
                    ],
                },
                showType: null, // 类型： 单据、组织架构
                transOrgFlag: false,    // 是否跨组织架构
                comId: null,
                checkList: [
                    'comIn'
                ]
            }
        },
        created: function () {
        },
        methods: {
            notityChange: function (eventData) {
                this.comId = eventData.id;
            },
            loadStaffList: function (transOrgFlag) {
                if(!transOrgFlag) {
                    this.comId = null;
                }
            },
            getResultData: function () {
                let self = this;
                let resultData = {};
                // 处理选中结果
                if(this.isVoucher) {
                    let checkList = this.checkList;
                    //
                    resultData.comIn = checkList.contains('comIn');
                    resultData.comOut = checkList.contains('comOut');
                }
                //
                this.$refs["ruleForm"].validate(function (valid) {
                    if(valid) {
                        resultData.msgInfo = Utils.merge(self.msgInfo);
                        //
                        if(!self.isVoucher) {
                            let result = self.$refs.swb_com_staff_list_for_msg.getDlgResult() || null;
                            //
                            if(result.type === 'info') {
                                //
                                resultData.staffIds = result.data;
                            }
                        }
                    }
                });
                //
                return resultData;
            }
        }
    }
</script>
<style>
    .tree-structure-collapse + .el-tree {
        margin-top: 0;
    }
</style>



// WEBPACK FOOTER //
// src/compo/msg/SendMsgMail.vue